import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectWisdomIssues(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { wisdomMessages } = context;

  if (!wisdomMessages || wisdomMessages.length === 0) return problems;

  // Check for wisdom timeout patterns (multiple "..." responses)
  const timeoutResponses = wisdomMessages.filter((msg) => msg.participant === 'BOT' && msg.value.text.value === '...');

  if (timeoutResponses.length >= 3) {
    problems.push({
      id: generateId(),
      type: ProblemType.WISDOM_TIMEOUT,
      severity: ProblemSeverity.MEDIUM,
      title: 'Wisdom Response Delays',
      description: `Multiple timeout responses detected (${timeoutResponses.length} instances)`,
      timestamp: timeoutResponses[0].timestamp,
      source: 'WISDOM_TRANSCRIPT',
      relatedData: { timeoutCount: timeoutResponses.length },
      suggestions: ['Check Wisdom service health', 'Review knowledge base configuration', 'Verify network connectivity']
    });
  }

  return problems;
}
